export const pinterestLink = "https://www.pinterest.com/verabradley/";
export const discordLink = "https://discord.gg/verabradley";
export const twitterLink = "https://twitter.com/verabradley";
export const instagramLink = "https://www.instagram.com/verabradley/";
export const facebookLink = "https://www.facebook.com/verabradley";
